import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Brain, ArrowRight } from 'lucide-react';
export function AccessFallacy() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#F8F8F8]" data-id="element-27">
      <div className="max-w-7xl mx-auto" data-id="element-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-29">
          {/* Left Column: Content */}
          <div data-id="element-30">
            <span className="text-sm font-bold tracking-widest uppercase text-gray-400 mb-4 block font-sans" data-id="element-31">
              The Access Fallacy
            </span>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight whitespace-nowrap font-['Syne']" data-id="element-32">
              Access is not intelligence.
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl font-light mb-12" data-id="element-33">
  You have plenty of access to information. Synthia gives AI access to
  expertise—<strong data-id="element-34"><em data-id="element-35">your</em></strong> judgment, experience, and institutional knowledge
  that turn data into decisions.
          </p>

            {/* Knowledge Cards Stacked */}
            <div className="space-y-6" data-id="element-36">
              {/* Explicit Knowledge Card */}
              <div className="bg-white p-6 rounded border border-gray-100" data-id="element-37">
                <div className="flex items-center gap-4 mb-4" data-id="element-38">
                  <div className="p-3 bg-gray-100 rounded-full" data-id="element-39">
                    <FileText className="w-6 h-6 text-gray-600" data-id="element-40" />
                  </div>
                  <h3 className="text-2xl font-bold font-['Syne']" data-id="element-41">
                    <span className="text-[#0066FF] text-[2.5rem]" data-id="element-42">30%</span>{' '}
                    Explicit Knowledge
                  </h3>
                </div>
                <p className="text-gray-600 leading-relaxed" data-id="element-43">
                  This is your current state—the files, PDFs, and databases that
                  models search. This is all that generic AI tries to retrieve.
                </p>
              </div>

              {/* Tacit Knowledge Card */}
              <div className="bg-black text-white p-6 rounded relative overflow-hidden" data-id="element-44">
                <div className="absolute top-0 right-0 w-64 h-64 bg-[#0066FF] opacity-10 blur-[80px] rounded-full translate-x-1/2 -translate-y-1/2" data-id="element-45"></div>
                <div className="flex items-center gap-4 mb-4 relative z-10" data-id="element-46">
                  <div className="p-3 bg-white/10 rounded-full" data-id="element-47">
                    <Brain className="w-6 h-6 text-white" data-id="element-48" />
                  </div>
                  <h3 className="text-2xl font-bold font-['Syne']" data-id="element-49">
                    <span className="text-[#0066FF] text-[2.5rem]" data-id="element-50">70%</span>{' '}
                    Tacit Knowledge
                  </h3>
                </div>
                <p className="text-gray-300 leading-relaxed relative z-10" data-id="element-51">
                  This is your "Judgment"—the unwritten rules, experience, and
                  expertise that actually drive professional decisions.
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Iceberg Graphic */}
          <div className="relative flex items-center justify-center min-h-[600px] mt-12" data-id="element-52">
            <img src="https://cdn.magicpatterns.com/uploads/jwqacCuebhBVswjHfuBbvy/final_iceberg11.png" alt="Knowledge Iceberg" className="w-full h-auto max-w-lg" data-id="element-53" />
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-6" data-id="element-54">
          <Link to="/how-it-works" onClick={scrollToTop} className="flex items-center gap-2 px-8 py-4 bg-[#0066FF] text-white font-['Syne'] font-bold text-sm tracking-wide uppercase hover:bg-black transition-all duration-200 hover:scale-105 w-fit" data-id="element-55">
            SEE HOW IT WORKS
            <ArrowRight className="w-5 h-5" data-id="element-56" />
          </Link>
        </div>
      </div>
    </section>;
}